import { put, select, takeEvery } from 'redux-saga/effects';
import { TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { ThhPferdActions } from '../thhPferdActions';
import { selectSelectedVersSumme } from '../../app/shared/selectors/produkt.selector';

export function* watchVersicherungssummen() {
  yield takeEvery(
    ThhPferdActions.ZUM_ANGEBOT_BUTTON_CLICKED,
    safeSaga(changeVersicherungssumme, App.THH_PFERD),
  );
  yield takeEvery(TARIF_CHECKED, safeSaga(changeVersicherungssumme, App.THH_PFERD));
}

export function* changeVersicherungssumme() {
  const versSummeLeistung: number = yield select(selectSelectedVersSumme);
  if (versSummeLeistung) {
    yield put(new ThhPferdActions().versicherungsSummeChanged(versSummeLeistung));
  }
}
